module.exports = __webpack_public_path__ + "img/provision-operator.662e3425.svg";